<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{
        'pricing.country.priceHistory.title'
          | translate: { bundle: row()?.name }
      }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <label class="label mb-1">
          {{ 'pricing.country.priceHistory.typeFilter' | translate }}
        </label>
        <app-select
          class="d-block"
          data-cy="country-history-type-select"
          [selected]="typeFilter()"
          (changed)="typeFilter.set($event)"
        >
          @for (filter of typeFilters; track filter) {
            <app-select-option
              [label]="
                'pricing.country.priceHistory.filters.' + filter | translate
              "
              [value]="filter"
            />
          }
        </app-select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-data-table [configuration]="dataTableConfiguration" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      ngbAutofocus
      type="button"
      class="btn btn-clear"
      data-cy="close-btn"
      (click)="modalRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #priceColumnTemplate let-row="row">
  @if (row.price !== null && row.price !== undefined) {
    <div class="caption">
      {{ row.price | number: '1.2-2' }} {{ pricingCountry()?.currency }}
    </div>
  } @else {
    <div class="caption text-danger">
      {{ 'pricing.country.details.missingPrice' | translate }}
    </div>
  }
</ng-template>

<ng-template #generatedByColumnTemplate let-row="row">
  @if (row.generatedBy) {
    <span class="caption">
      <app-user-display [userId]="row.generatedBy" />
    </span>
  }
</ng-template>
